const statementsIT = {
    "view": {
        "table": {
            "title": "La tua lista di estratti conto",
            "column": {
                "type": "Tipo",
                "year": "Anno",
                "month": "Mese",
                "issue_year": "Anno di Emissione",
                "issue_month": "Mese di Emissione",
                "description": "Descrizione",
                "amount": "Importo",
                "status": "Stato",
                "details": "Dettagli",
                "overview": "Panoramica"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "label": {
                "status_open": "Aperto",
                "status_paid": "Pagato",
                "status_on_hold": "In sospeso",
                "type_licensing": "Licenza",
                "type_regular": "Regolare",
                "type_audio_mastering_services": "Mastering Audio - Servizi",
                "type_vinyl_earnings": "Guadagni Vinile",
                "type_offset": "Compensazione",
                "type_not_known": "Non Conosciuto",
                "month_january": "Gennaio",
                "month_february": "Febbraio",
                "month_march": "Marzo",
                "month_april": "Aprile",
                "month_may": "Maggio",
                "month_june": "Giugno",
                "month_july": "Luglio",
                "month_august": "Agosto",
                "month_september": "Settembre",
                "month_october": "Ottobre",
                "month_november": "Novembre",
                "month_december": "Dicembre"
            },
            "button": {
                "download": "Scarica",
                "exportCsv": "Esporta CSV"
            }
        },
        "message": {
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    }
};

export default statementsIT;